<template>
  <div class="main">
    <Header></Header>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
export default {
  name: 'MainLayout',
  components: { Header, Footer }
}
</script>

<style lang="scss">
.main {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/MainLayout.vue